<template>
	<wxs src="./index.wxs" module="tools"></wxs>
	<view class="es-content">
		<!-- 基础信息：姓名、手机号、英文姓、英文名 -->
		<view class="es-content__box es-content__card">
			<view class="es-content__change">
				<es-change-btn wx:model="{{changeBtnValue}}" wx:if="{{showChangeBtn}}" />
			</view>
			<es-card
				layout="{{['header']}}"
        style="{{ {'padding-bottom': '16px'} }}"
				custom-header="es-content__miniapp_card_header"
				custom-body="es-content__miniapp_card_body"
			>
				<view slot="header">基础信息</view>
				<view class="es-content__name-tips">
					<view class="es-content__name-tips-content">{{ nameTipsContent }}</view>
					<view class="es-content__name-tips-entrance" bindtap="handleDialogVisible">
						填写说明
						<es-icon class="es-content__name-info" name="angle-right" color="#999999" />
					</view>
				</view>
				<view wx:for="{{changeBtnValue === 'Chinese'?baseContentData:englishBaseContentData}}">
					<component
						is="{{item.component}}"
            isAddPage="{{isAddPage}}"
            userDetail="{{userDetail}}"
						wx:model="{{baseData[item.name]}}"
						isRequiredShow="{{isRequiredShow}}"
						isShow="{{item.isShow}}"
						isNameDisable="{{isNameDisable}}"
						isEnNameDisable="{{isEnNameDisable}}"
						isPhoneDisable="{{isPhoneDisable}}"
						isPassengerTypeDisable="{{isPassengerTypeDisable}}"
						bind:phone-focus="phoneFocus"
						item="{{item}}"
						selectedCardList="{{selectedCardList}}"
						showChangeBtn="{{showChangeBtn}}"
					/>
					<!-- <es-contact-name wx:model="{{baseData['passenger_name']}}" isNameDisable="{{isNameDisable}}" isRequiredShow="{{isRequiredShow}}" /> -->
					<!-- <es-contact-phone wx:model="{{mobile_no}}" bind:phone-focus="phoneFocus" isPhoneDisable="{{isPhoneDisable}}" isRequiredShow="{{isRequiredShow}}"/>
          <es-english-surname wx:model="{{english_surname}}" isPinyinShow="{{isPinyinShow}}" isPinyinRequired="{{isPinyinRequired}}" isRequiredShow="{{isRequiredShow}}"/>
          <es-english-name wx:model="{{english_name}}" isPinyinShow="{{isPinyinShow}}" isPinyinRequired="{{isPinyinRequired}}" isRequiredShow="{{isRequiredShow}}"/> -->
				</view>
			</es-card>
		</view>
		<!-- 其它信息：出生日期、性别、昵称、备注  其中 安全整改 干掉性别、昵称、备注-->
		<view wx:if="{{isShowOtherContent}}" class="es-content__box es-content__card" wx:style="{{hasBtoom}}">
			<es-card custom-body="es-content__miniapp_card_body">
				<view wx:for="{{otherContentData}}">
					<component
						is="{{item.component}}"
						wx:model="{{baseData[item.name]}}"
						isRequiredShow="{{isRequiredShow}}"
						isShow="{{ item.isShow }}"
						item="{{item}}"
						selectedCardList="{{selectedCardList}}"
						isSexDisable="{{isNameDisable}}"
						isNationlityDisable="{{isNationlityDisable}}"
						isBorndateDisable="{{isBorndateDisable}}"
						isNeedCard="{{isNeedCard}}"
					/>
				</view>
				<!-- <es-birth-date wx:model="{{birth_date}}" isBirthShow="{{isBirthShow}}"isBirthdayRequired="{{isBirthdayRequired}}" isRequiredShow="{{isRequiredShow}}" />
        <es-contact-sex wx:model="{{sex}}" isGenderShow="{{isGenderShow}}" isGenderRequired="{{isGenderRequired}}" isRequiredShow="{{isRequiredShow}}"/>
        <es-contact-nickname wx:model="{{nickname}}" isNicknameShow="{{isNicknameShow}}"/>
        <es-contact-remark wx:model="{{remark}}" isRemarkShow="{{isRemarkShow}}"/>
        <es-nationlity wx:model="{{nationlity}}" isNationalityShow="{{isNationalityShow}}" isRequiredShow="{{isRequiredShow}}"/> -->
			</es-card>
		</view>
		<!-- <view
			class="es-content__tip-text"
			wx:style="padding: 0px 14px;display:flex"
			wx:if="{{isBirthdayRequired}}"
		>
			<es-icon name="exclamation-circle" color="#999999" size="11" class="es-content__tips-icon" />
			{{ birthDateTips }}
		</view> -->
		<!-- 证件列表 -->
		<!-- <view wx:if="{{canAdd}}"> -->
		<!-- <view bindtap="updataView"> -->
		<es-card-list
      isAddPage="{{isAddPage}}"
			wx:model="{{selectedCardList}}"
			isCardListShow="{{isCardListShow}}"
			isRequiredShow="{{isRequiredShow}}"
			isOneCardShow="{{false}}"
			secret_key="{{secret_key}}"
			cardTypeList="{{cardTypeList}}"
			expireDateConfig="{{expireDateConfig}}"
			aesOriginCardList="{{aesOriginCardList}}"
			selectedCardType="{{selectedCardType}}"
			initSelectedCardList="{{ initSelectedCardList }}"
			selected_card_type="{{selected_card_type}}"
			isIdTypeDisable="{{isIdTypeDisable}}"
			isIdNoDisable="{{isIdNoDisable}}"
		/>
		<!-- 学生购票说明卡片 -->
		<view class="es-content__box es-content__card" wx:if="{{isStudent && !isExemption}}">
			<student-card></student-card>
		</view>
		<!-- 儿童购票说明卡片 -->
		<view class="es-content__box es-content__card" wx:if="{{isChild}}">
			<child-card></child-card>
		</view>
		<!-- </view> -->
		<!-- </view> -->
		<!-- 提示文案 -->
		<es-tip-text wx:if="{{!isMyself}}" wx:model="{{isRead}}" category="{{category}}" />
	</view>
</template>

<script>
  import { findIndex, cloneDeep } from 'lodash'
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import store from '@/store'
  import { AES_ECB_DECRYPT, AES_ECB_ENCRYPT, SECRETKEY } from '@/common/crypto'
  import Validator from '@/utils/validator'
  import { getStorage } from '@/utils/storage'
  import { addContact, editContact, addTraveler, editTraveler } from '@/api/contact/index'
  import {
    PageSource,
    CategoryType,
    AppointmentText,
    SceneType,
    SubTypeConst,
    ApprovalType,
    NeedCardType
  } from '@/utils/constants'
  import { USER_ADD_TOC, USER_UPDATE_TOC, GET_VERIFY_AGE } from '@/api/urls'
  import { desensitizePhone, desensitizeCardId, hasRequired, permitValidateConf } from '@/utils'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import {
    contentConfig,
    componentsConfig,
    nameTipsConfig,
    birthDateTipsConfig
  } from '@/config/content/index'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { innerRouter, pagePath } from "@/common/jump";
  //基础数据
  let baseArr = ['passenger_name', 'passenger_type', 'encrypt_phone']
  let otherArr = ['born_date', 'sex', 'nickname', 'remark', 'nationlity']
  let englishBaseArr = ['english_surname', 'english_name', 'encrypt_phone']

  createComponent({
    props: {
      userId: {
        type: String,
        value: ''
      },
      isNeedCard: {
        type: Boolean,
        value: true
      },
      needApproval: {
        type: String,
        value: ApprovalType.no
      },
      selected_card_type: {
        type: String,
        value: ''
      },
      isAddPage: {
        type: Boolean,
        value: true
      },
      isDelay: {
        type: Boolean,
        value: false
      }
    },
    data() {
      let baseData = {}
      let temp = [...baseArr, ...otherArr].map((item) => {
        if (item === 'nationlity') {
          baseData[item] = {}
        } else if (item === 'passenger_type') {
          baseData[item] = 0
        } else {
          baseData[item] = ''
        }
      })

      // baseData:{
      //   passenger_name: '', // 姓名
      //   mobile_no: '', // 手机号码
      //   english_surname: '', // 拼音姓
      //   english_name: '', // 拼音名
      //   birth_date: '', // 出生日期
      //   sex: '', // 性别
      //   nickname: '', // 昵称
      //   remark: '', // 备注
      // }
      return {
        category: 'train',
        selectedCardList: [], // 选中的证件类型
        initSelectedCardList: [], //初始化选中的证件类型
        cardTypeList: [], // 可选的证件类型
        aesOriginCardList: [], // 接口返回的解密的证件列表
        // isDialogShow: false,
        secret_key: '',
        endDate: formatDate(),
        isRead: false, // 授权阅读
        selectedCardType: '',
        isBirthdaySelectShow: false,
        phoneIsOrgin: true, //是否是原始的数据
        isShowDialog: false,
        // 使用场景的配置
        contentConfig: {},
        //基础数据
        baseContentData: {},
        //其他数据
        otherContentData: {},
        //只有英文模式基础数据
        englishBaseContentData: {},
        orgin_contact_phone: '', // 备份的原始手机号码
        baseData,
        changeBtnValue: 'Chinese',
        initEnName: true, //初始的英文姓名
        is_user_self: 0, //是否是本人 0 不是，1 是
        user_status: 0 // 身份是否核验通过 0 否 1 是
      }
    },

    watch: {
      editData: {
        handler(target) {
          const { userId, contactDetail, originCardTypeList } = target
          this.cardTypeList = [...originCardTypeList]
          if (!userId || !contactDetail) return

          const displayContactDetail = cloneDeep(contactDetail?.list || {})
          const {
            passenger_name,
            passenger_type,
            encrypt_phone,
            mobile_no,
            born_date,
            id_type,
            id_name,
            id_no,
            card_type,
            country_code,
            country_name_cn,
            sex,
            nickname,
            remark,
            is_user_self,
            user_status,
            valid_date_end
          } = displayContactDetail
          console.log('displayContactDetail===>', displayContactDetail)
          let nationlity = {
            country_code: country_code || '',
            country_name_cn: country_name_cn || ''
          }
          // let mobile_no = mobile_no
          this.baseData = {
            ...this.baseData,
            passenger_name: passenger_name || '',
            born_date: AES_ECB_DECRYPT(born_date || ''),
            passenger_type: passenger_type || 0,
            sex: sex || 'M',
            nickname: nickname || '',
            remark: remark || '',
            encrypt_phone: encrypt_phone || '',
            mobile_no: AES_ECB_DECRYPT(mobile_no || ''),
            nationlity,
            user_status
          }
          this.setNationality(nationlity)
          this.orgin_contact_phone = encrypt_phone
          // this.initEnName = Boolean(english_name && english_surname)
          //如果中文没有，并且英文有的时候切换到英文模式
          // this.secret_key = personal_secret_key
          this.is_user_self = is_user_self
          this.user_status = user_status
          const expire_date = AES_ECB_DECRYPT(valid_date_end || '')
          const selected = []
          this.cardTypeList &&
            this.cardTypeList.map((item) => {
              if (item.code === id_type) {
                const selectedItem = {
                  ...item,
                  id_type,
                  card_type: id_type,
                  id_no,
                  card_name: id_name
                }
                if(this.isExemption && expire_date) {
                  selectedItem.expire_date = expire_date
                }
                selected.push(selectedItem)
              }
            })
          // const res =
          //   (card_list &&
          //     card_list?.map((card) => {
          //       const { card_type } = card
          //       const index = findIndex(this.cardTypeList, (item) => {
          //         return item.code == card_type
          //       })
          //       card.isChange = false
          //       if (index !== -1) {
          //         // card.card_no = AES_ECB_DECRYPT(card.secret_card_no, personal_secret_key);
          //         card.items = this.cardTypeList[index].items
          //         this.cardTypeList.splice(index, 1)
          //         return card
          //       }
          //       return card
          //     })) ||
          //   []
          // console.log('card_list---', card_list, res)
          // // this.card_type = id_type
          // const temp =
          //   card_list &&
          //   card_list.map((card) => {
          //     // card.card_no = AES_ECB_DECRYPT(card.secret_card_no, personal_secret_key);
          //     return card
          //   })

          // this.aesOriginCardList = temp
          // this.selectedCardList = res
          this.initSelectedCardList = selected
        }
      },

      changeBtnValue(value) {
        this.init(value)
      }
    },

    computed: {
      ...store.mapGetters({
        isExemptionOrigin: 'makeOrder.isExemption',
      }),
      ...store.mapState({
        secretKey: 'newContacts.secretKey',
        originCardTypeList: 'newContacts.cardTypeList',
        contactDetail: 'newContacts.contactDetail',
        selectedContacts: 'newContacts.selectedContacts',
        nationality: 'newContacts.nationality',
        externalContacts: 'newContacts.externalContacts',
        is12306Login: 'login12306.is12306Login',// 是否已登录12306
      }),
      isExemption() {
        // 编辑页需要从乘车人信息中取是否是本地乘车人
        if(!this.isAddPage){
          return this.$mpxRoute.query.passenger_source === '1' ? 1 : 0
        }
        // 新增页面按照原有流程标识处理
        return this.isExemptionOrigin
      },
      // 用户详情
      userDetail() {
        return this.contactDetail?.list || {}
      },
      showChangeBtn() {
        return this.category === 'hotel' && !this.isNeedCard
      },
      nameTipsContent() {
        return nameTipsConfig[this.category]
      },
      hasBtoom() {
        return !this.isBirthdayRequired || {}
      },
      showSaveSwitch() {
        return false
      },
      // 本人，手机号相同就是本人
      isMyself() {
        return Boolean(+this.is_user_self)
      },
      isUserStatus() {
        return Boolean(this.user_status === '1')
      },
      // 姓名是否可以修改：身份核验通过之后都不可以修改
      isNameDisable() {
        return !this.isExemption && !!this.userId && this.isUserStatus
      },
      // 国籍是否可以修改：身份核验通过之后且证件类型为护照的时候不可以修改
      isNationlityDisable() {
        return !this.isExemption && Boolean(!!this.userId && this.isUserStatus && this.isPassport)
      },
      // 出生日期是否可以修改： 身份核验通过之后 且 证件类型是港澳居民来往内地通行证、台湾居民来往大陆通行证
      isBorndateDisable() {
        return !this.isExemption && Boolean(!!this.userId && this.isUserStatus)
      },
      // 是否是港澳居民来往内地通行证、台湾居民来往大陆通行证
      isTXZ() {
        return (
          this.selectedCardList &&
          this.selectedCardList.length &&
          (this.selectedCardList[0].code === 'C' || this.selectedCardList[0].code === 'G')
        )
      },
      isPassport() {
        return (
          this.selectedCardList &&
          this.selectedCardList.length &&
          this.selectedCardList[0].code === 'B'
        )
      },
      // 证件类型是否可以修改: 身份核验通过之后都不可以修改
      isIdTypeDisable() {
        return !this.isExemption && !!this.userId && this.isUserStatus
      },
      isIdNoDisable() {
        return !this.isExemption && !!this.userId && this.isUserStatus
      },
      isEnNameDisable() {
        return !this.isExemption && this.isNameDisable && this.initEnName
      },
      isPhoneDisable() {
        return !this.isExemption && !!this.userId && this.isUserStatus && this.isMyself
      },
      isPassengerTypeDisable() {
        return !this.isExemption && !!this.userId && this.isUserStatus && this.isMyself
      },

      // isPinyinRequired() {
      //   // 护照、外国人永久居留身份证、公务护照、外交护照，拼音名必填
      //   const cardTypes = ['2', '7', '9', '10']
      //   return this.checkRequire(cardTypes)
      // },
      isBirthdayRequired() {
        // 除身份证外的其他证件，出生日期必填
        let itemConfig = this.contentConfig?.born_date || {}
        return hasRequired(
          itemConfig?.requiredcCrdTypes || [],
          this.selectedCardList,
          itemConfig?.isRequired,
          this.isNeedCard
        )
      },
      // 是否展示其他信息模块
      isShowOtherContent() {
        const curSelectedType = this.selectedCardList?.[0]?.code
        // 类型为护照、港澳居民来往内地通行证、台湾居民来往大陆通行证、外国人永久居留证时展示
        return ['B', 'C', 'G', 'H'].includes(curSelectedType)
      },
      // isGenderRequired() {
      //   // 台胞证、回乡证、往来港澳通行证，性别必填
      //   const cardTypes = ['4', '6', '8']
      //   return false
      //   // return this.checkRequire(cardTypes)
      // },
      expireDateConfig() {
        return this.contentConfig?.expire_date || {}
      },
      editData() {
        const { userId, originCardTypeList, contactDetail } = this
        return {
          userId,
          contactDetail,
          originCardTypeList
        }
      },

      // 是否展示证件信息
      isCardListShow() {
        return this.isNeedCard
      },
      // 是否展示必填*号
      isRequiredShow() {
        return true
      },
      // 是否展示备注
      // isRemarkShow() {
      //   // 因公、编辑、公司维护外部出行人
      //   // return (
      //   //   this.scene == SceneType.forBusiness &&
      //   //   this.subType == SubTypeConst.company_business &&
      //   //   !!this.userId
      //   // )

      //   // return false
      //   //调试，暂时为true
      //   return true
      // },

      // birthDateTips() {
      //   return birthDateTipsConfig[this.category]
      // },
      // 乘车人类型是否是学生
      isStudent() {
        return this.baseData.passenger_type === 2
      },
      // 乘车人类型是否是儿童
      isChild() {
        return this.baseData.passenger_type === 1
      }
    },

    methods: {
      ...store.mapMutations({
        refreshUserCardList: 'newContacts.refreshUserCardList',
        setNationality: 'newContacts.setNationality',
        setExternalContacts: 'newContacts.setExternalContacts',
        setContactSelected: 'newContacts.setContactSelected',
        contactDetailSuccess: 'newContacts.contactDetailSuccess'
      }),
      // ...store.mapActions({
      //   getContactDetailAction: 'newContacts.getContactDetailAction'
      // }),
      // updataView(){
      //   this.$trigger('updata-view')
      // },
      init(mode) {
        this.contentConfig = contentConfig['train']
        this.baseContentData = {}
        this.otherContentData = {}
        if (mode == 'english') {
          this.contentConfig = contentConfig['englishModeHotel']
          englishBaseArr.map((item) => {
            this.contentConfig[item] &&
              (this.englishBaseContentData[item] = {
                ...this.contentConfig[item],
                component: componentsConfig[item],
                name: item
              })
          })
        }

        baseArr.map((item) => {
          if(this.contentConfig[item]) {
            this.baseContentData[item] = {
              ...this.contentConfig[item],
              component: componentsConfig[item],
              name: item
            }
          }
        })
        otherArr.map((item) => {
          this.contentConfig[item] &&
            (this.otherContentData[item] = {
              ...this.contentConfig[item],
              component: componentsConfig[item],
              name: item
            })
        })
        this.$forceUpdate()
        console.log(this.contentConfig, '====this.contentConfig======')
        console.log(this.baseContentData, '=this.baseContentData=====')
        console.log(this.otherContentData, '=this.otherContentData=======')
      },
      surNameBoxBlur(e) {
        let { value } = e?.detail || {}
        setTimeout(() => {
          this.english_surname = (value + '').toUpperCase()
        }, 100)
      },
      englishNameBoxBlur(e) {
        let { value } = e?.detail || {}
        setTimeout(() => {
          this.english_name = (value + '').toUpperCase()
        }, 100)
      },
      // 删除常用联系人按钮，所以这方法也去掉了
      // contentTap() {
      //   this.$refs['saveSwitchRef'].hideSaveIconToast()
      // },

      //联系电话输入框聚焦
      phoneFocus() {
        if (!this.phoneIsOrgin) {
          return
        }
        this.baseData.encrypt_phone = ''
        this.baseData.mobile_no = ''
        this.phoneIsOrgin = false
      },

      // 显示姓名填写提示
      handleDialogVisible() {
        this.$trigger('change')
      },
      isCardExpiredShow(selectedCard) {
        console.log('isCardExpiredShow====>', selectedCard)
        return hasRequired(
          this.expireDateConfig?.requiredcCrdTypes || [],
          selectedCard,
          this.expireDateConfig?.isRequired,
          this.isNeedCard
        )
      },

      // 校验
      validateFunc() {
        var validator = new Validator()
        const NULLREG = '^[sS]*.*[^s][sS]*$'
        const MOBILEREG = '^1\\d{10}$'
        const CHN_NAME_REG = '^[a-zA-Z0-9_\u4e00-\u9fa5 ]+$'
        const ENG_NAME_REG = '^[a-zA-Z0-9_ ]+$'
        const SEX_NULL_REG = '^[^0]$'

        const {
          passenger_name,
          encrypt_phone,
          // english_surname,
          // english_name,
          born_date,
          sex,
          nickname,
          remark,
          nationality
        } = this.baseData
        console.log('this.base=====>', this.baseData)
        //常用出行人需填写中文或英文姓名

        let allArr = [...baseArr, ...otherArr]
        allArr.forEach((key) => {
          let itemConfig = this.contentConfig[key]
          let isRequired = hasRequired(
            itemConfig.requiredcCrdTypes,
            this.selectedCardList,
            itemConfig.isRequired,
            this.isNeedCard
          )
          if (isRequired) {
            validator.cbAdd(this.baseData[key], itemConfig.validator, itemConfig.tips)
            // 姓名校验增加checkName校验规则
            if(key === 'passenger_name') {
              validator.cbAdd(passenger_name, function(str, msg) {
                const REG = /^[.·a-zA-Z0-9_\u4e00-\u9fa5 /\\]+$/
                if(!REG.test(str || '' )) return msg
              }, '请输入格式汉字、字母、数字、下划线、斜杠、空格、点，姓名长度不超过30个字符')
              validator.cbAdd(passenger_name, function(str, msg) {
                if(str.length  > 50) return msg
              }, '姓名长度不可超过50个字符，若过长请用缩写')
            }
          }
        })

        // 证件信息
        let arrList = [...this.selectedCardList]
        // 需要证件时才添加校验条件
        if (this.isNeedCard && arrList.length > 0) {
          arrList.forEach((item) => {
            // 相对应证件的正则校验规则
            const validateConf = permitValidateConf(item)
            //如果是修改的证件||无证件号||从新增页进入的需要进入检验
            if (item.isChange || !item.id_no || this.isAddPage) {
              validator.cbAdd(item.id_no, validateConf, '请输入正确的证件号码')
            }
            if (this.isCardExpiredShow([item])) {
              if (!this.isAddPage) return
              validator.cbAdd(item.expire_date || '', NULLREG, '请选择证件有效期')
            }
          })
        }
        var errorMsg = validator.start()
        return errorMsg
      },
      // 统一的校验必填方法
      checkRequire(cardTypes) {
        let required = false
        let arrList = [...this.selectedCardList]
        arrList.forEach((item) => {
          if (item && cardTypes?.includes('' + item.card_type)) {
            required = true
            return
          }
        })
        return required
      },
      // 保存出生日期
      saveBirthDate() {
        this.born_date = formatDate(this.birth_date_model)
        this.isBirthdaySelectShow = false
      },
      // formatter(val, type) {
      //   const res = val.map(ele => {
      //     if (type === 'year') {
      //       ele += '年';
      //     }
      //     else if (type === 'month') {
      //       ele += '月';
      //     }
      //     else if(type === 'day') {
      //       ele += '日';
      //     }
      //     return ele;
      //   });
      //   return res;
      // },
      // 保存联系人
      async saveContact() {
        // 新增校验是否重复
        if(this.isAddPage) {
          const {
            card_type,
            id_no = ''
          } = this.selectedCardList[0]
          const {
            passenger_name,
            passenger_type,
          } = this.baseData
          const slice_encrypt_id_no = id_no.substring(0,4) + id_no.slice(-3)
          const currentPassengerKey = passenger_name + passenger_type + card_type + slice_encrypt_id_no
          const uniquePassengerKeys = this.$mpxRoute.query.uniquePassengerKeys || []
          if(uniquePassengerKeys.includes(currentPassengerKey)) {
            Toast({
              message: '已有相同的乘车人，勿重复添加！',
              overlay: false
            })
            return
          }
        }
        const errMsg = this.validateFunc()
        if (errMsg) {
          Toast({
            message: errMsg,
            overlay: false
          })
          return
        }

        if (!this.isRead) {
          Toast({
            message: '请先阅读并同意下方授权内容',
            overlay: false
          })
          return
        }
        const data = this.makeData()
        //如果姓名不可点击+原英文名/姓为空+后面传的有值（如果必填前面没填是会拦截的）
        if (this.isNameDisable && !this.initEnName) {
          Dialog.confirm({
            title: '温馨提示',
            message: '员工/公司维护外部出行人英文姓名添加后不可再次修改，请确认无误',
            cancelButtonText: '取消',
            confirmButtonText: '保存',
            confirm: async () => {
              await this.save(data)
            }
          })
          return
        }
        // 是否编辑了身份证号
        const isChangeIdNo = this.selectedCardList.find((item) => item.id_no && item.isChange && !this.isAddPage)
        // 新增或者编辑了身份信息，获取用户出生日期
        if (isChangeIdNo || this.isAddPage) {
          const born_date = data.id_no.substr(6, 8)
          const res = await this.verifyAge(born_date) || {}
          if (+res.code === 0 && res.data && !res.data.is_adult) {
            Dialog.confirm({
              title: '儿童监护人确认',
              message: res.data.tips || '您正在录入未成年人的个人信息，请确认您是该未成年人的监护人或已征得该未成年人监护人的同意，授权我们按照儿童个人信息处理规则及个人信息共享相关授权协议中说明的情况处理该未成年人的个人信息',
              cancelButtonText: '取消',
              confirmButtonText: '确认',
              confirm: async () => {
                await this.save(data)
              }
            })
            return
          } else {
            await this.save(data)
          }
        } else {
          await this.save(data)
        }
      },
      delay(slefSaveData) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            this.contactDetailSuccess({ data: { ...slefSaveData, isNewDate: true } })
            resolve()
          }, 500)
        })
      },
      async verifyAge(bornDate) {
        return mpx.$http.post(GET_VERIFY_AGE, {
          data: {
            born_date: bornDate,
          },
        })
      },
      async save(data) {
        for (const key in data) {
          if (key === 'id_no') {
            data[key] = AES_ECB_ENCRYPT(data[key])
          }
        }
        const res = await this[this.isAddPage ? 'savePassenger' : 'updatePassenger']({ user: data })
        if (+res?.code) {
          if (+res?.code === 10528) { // 人证不符
            Dialog.alert({
              title: '温馨提示',
              message: res?.message || '您的姓名或证件号可能有误，请仔细核对，以免影响出行',
              confirmButtonText: '我知道了',
              confirm: () => {},
              cancel: () => {}
            })
          } else {
            Toast({
              message: res?.message || '网络错误, 请稍后重试',
              overlay: false
            })
          }
        } else {
          Toast({
            message: res?.data?.msg || '网络错误, 请稍后重试',
            overlay: false
          })
          if (res?.data?.is_success) setTimeout(() => mpx.$mpxRouter.goback(), 650)
        }
        // if (this.userId) {
        //   data.id = this.userId
        //   data.sub_type = this.subType
        //   if (!this.innerIsTmpTraveler) {
        //     data.is_save = 1
        //   }
        //   let res

        //   if (res?.code == 0) {
        //     //如果是临时外部出行人
        //     if (this.innerIsTmpTraveler) {
        //       const slefSaveData = this.saveSlefData()
        //       slefSaveData.id = res?.data?.id || this.userId //给编辑做兜底，如果后端没有给返回的情况
        //       this.setExternalContacts(slefSaveData)

        //       //在编辑/新增自己维护的出行人保存成功的时候，添加一个标记，给列表页清楚，这个是编辑/新增页的contactDetailSuccess
        //       if (this.isDelay) {
        //         await this.delay(slefSaveData)
        //       } else {
        //         this.delay(slefSaveData)
        //       }

        //       //如果是选中的临时出行人，则要更新其在selectedContacts里面的数据
        //       const selectIndex = this.selectedContacts.findIndex(
        //         (list) => list.id == slefSaveData.id
        //       )
        //       if (selectIndex !== -1) {
        //         this.setContactSelected({ data: slefSaveData, fn: 'splice' })
        //       }
        //     } else {
        //       if (this.isDelay) {
        //         await this.fetchUserDetail(res.data.id || this.userId)
        //       } else {
        //         this.fetchUserDetail(res.data.id || this.userId)
        //       }
        //     }
        //   } else {
        //     return Toast({
        //       message: res?.message,
        //       overlay: false
        //     })
        //   }
        // }
        // // 新增
        // else {
        //   let res

        //   if (res?.code !== 0) {
        //     return Toast({
        //       message: res?.message,
        //       overlay: false
        //     })
        //   } else {
        //     // TODO 这块逻辑是否需要去掉？
        //     if (this.isDelay) {
        //       await this.fetchUserDetail(res.data.id)
        //     } else {
        //       this.savePassenger(data)
        //     }
        //   }
        // }
        await this.refreshUserCardList(null)
        await this.refreshUserCardList(this.userId)
      },
      //根据手机号判断 用户在选择出行人页面是否已存在
      hasExitExternalContact(contactData) {
        let result = this.externalContacts?.some((item) => {
          return item.encrypt_phone == contactData.encrypt_phone
        })
        return result
      },

      makeData() {
        const {
          passenger_name,
          passenger_type,
          encrypt_phone,
          mobile_no,
          born_date,
          // english_surname,
          // english_name,
          sex,
          nickname,
          remark,
          nationality
        } = this.baseData
        const contactInfo = this.contactDetail?.list ?? {}
        // 姓名手机号必填
        let phone = this.phoneIsOrgin ? this.orgin_contact_phone : encrypt_phone
        //转大写，因为内部的按钮是失焦的时候转，可能用户填写完之后就直接提交了，没有走失焦的逻辑，所以这里统一处理
        const data = {
          passenger_type,
          id: this.userId,
          is_user_self: this.isMyself,
          passenger_name: passenger_name.replace(/\s+/g, '').toUpperCase(),
          encrypt_phone: AES_ECB_ENCRYPT(phone), // 手机号需加密
          mobile_no: AES_ECB_ENCRYPT(encrypt_phone)
          // english_surname: english_surname.replace(/\s+/g, '').toUpperCase(),
          // english_name: english_name.replace(/\s+/g, '').toUpperCase()
        }

        // 出生日期
        if (born_date) {
          data.born_date = AES_ECB_ENCRYPT(born_date) // 出生日期需加密
        }

        // 性别
        if (sex && sex !== '0') {
          data.sex = String(sex)
        }

        // 昵称
        if (nickname) {
          data.nickname = nickname
        }

        // 备注
        if (remark) {
          data.remark = remark
        }
        // 国籍
        if (this.nationality?.country_code) {
          data.country_code = this.nationality?.country_code || ''
        }

        // 证件信息
        let arrList = [...this.selectedCardList]

        if (arrList.length > 0 && this.isNeedCard) {
          const credentialInfo = arrList[0]
          Object.assign(data, {
            id_no: credentialInfo?.id_no,
            card_type: credentialInfo?.code,
            id_type: credentialInfo?.code,
            id_name: credentialInfo?.name,
            valid_date_end: AES_ECB_ENCRYPT(credentialInfo?.expire_date)
          })
        }
        return data
      },

      // // 获取用户详情，保存
      // async fetchUserDetail(userId) {
      //   await this.getContactDetailAction({
      //     contact_id: userId,
      //     isNewDate: true,
      //     order_type: this.isExemption || Number(!this.is12306Login)
      //   })
      // },

      async savePassenger(params) {
        return mpx.$http.post(USER_ADD_TOC, { 
          data: {
            ...params,
            order_type: this.isExemption || Number(!this.is12306Login)
          },
        })
      },

      async updatePassenger(params) {
        return mpx.$http.post(USER_UPDATE_TOC, { 
          data: {
            ...params,
            order_type: this.isExemption || Number(!this.is12306Login)
          },
        })
      }
    },
    mounted() {
      //清空存放的数据
      // TODO 这块逻辑是否去掉？
      this.selectedCardType = this.selected_card_type
      this.setNationality({})
      this.$forceUpdate()
      this.init()
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('box')
      margin 12px
      position relative
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        // &::after
        // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color #333333 !important
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px
    // 小程序用
    +e('tip-text')
      color #999999
      font-size 12px
      text-align justify
    +e('tips-icon')
      font-size 12px
      line-height 17px
      margin-right 3px
      color #999999
    +e('name-tips')
      display flex
      justify-content space-between
      align-items center
      margin -4px -12px 0 -12px
      padding 0 12px
      height 32px
      background-image linear-gradient(270deg, #FFFFFF 0%, #FFF4EE 100%)
    +e('name-tips-content')
      font-family PingFangSC-Regular
      font-size 12px
      color #FF6221
    +e('name-tips-entrance')
      display flex
      align-items center
      font-family PingFangSC-Regular
      font-size 12px
      color #666666
      text-align right
      line-height 12px
    +e('change')
      position absolute
      z-index 1
      top 80px
      right 12px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-card': '@didi/es-mpx-ui/lib/card',
      'es-contact-name': './components/contact-name',
      'es-contact-type': './components/contact-type',
      'es-contact-phone': './components/contact-phone',
      'es-english-surname': './components/english-surname',
      'es-english-name': './components/english-name',
      'es-birth-date': './components/birth-date',
      'es-contact-sex': './components/contact-sex',
      'es-contact-nickname': './components/contact-nickname',
      'es-contact-remark': './components/contact-remark',
      'es-nationlity': './components/nationlity',
      'es-card-list': './components/card-list',
      'es-save-switch': './components/save-switch',
      'es-tip-text': './components/tip-text',
      'es-change-btn': './components/change-btn',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'student-card': './components/student-card',
      'child-card': './components/child-card'
    }
  }
</script>
